module.exports = __webpack_public_path__ + "static/media/component-google-maps-card.10763db4.png";